import { LightningElement, api, track } from "lwc";
import { withImageProxy } from "common/withImageProxy";
import { getAssetsUrl } from "common/helpers";

var placeholderImg =
  "data:image/svg+xml,%3Csvg%20enable-background%3D%22new%200%200%20180%20181%22%20viewBox%3D%220%200%20180%20181%22%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%3E%20%20%20%20%3Ccircle%20cx%3D%2290%22%20cy%3D%2290%22%20fill%3D%22%23dedede%22%20r%3D%2290%22%2F%3E%3C%2Fsvg%3E";

class headerAvatar extends LightningElement {
  @api imgSrc = "";
  @api percent = null;
  @track imgSrcProxy = getAssetsUrl(placeholderImg);

  async connectedCallback() {
    this.imgSrcProxy = await withImageProxy(this.imgSrc);
  }

  get d() {
    if (!this.percent) return "";
    let isLong = this.percent > 50 ? 1 : 0;
    let fill = 1 - this.percent / 100;
    let arcX = Math.cos(2 * Math.PI * fill);
    let arcY = Math.sin(2 * Math.PI * fill);
    return `M 1 0 A 1 1 0 ${isLong} 0 ${arcX} ${arcY} L 0 0`;
  }
}

export default headerAvatar;
